module.exports = __webpack_public_path__ + "img/xx@2x.397373e9.png";